import React from 'react';

type FormSwitchProps = {
    label: string;
    name: string;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
};

const FormSwitch = ({ label, name, checked = false, onChange, disabled }: FormSwitchProps) => {
    return (
        <div className="mb-4 flex items-center gap-3">
            <span className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                {label}
            </span>
            <button
                type="button"
                role="switch"
                aria-checked={checked}
                onClick={() => !disabled && onChange?.(!checked)}
                className="relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200"
                style={{
                    backgroundColor: checked ? 'var(--accent)' : 'var(--surface-300)',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    opacity: disabled ? 0.5 : 1,
                    border: 'none',
                    padding: 0,
                }}
            >
                <span
                    className="inline-block h-4 w-4 rounded-full bg-white transition-transform duration-200"
                    style={{
                        transform: checked ? 'translateX(24px)' : 'translateX(4px)',
                    }}
                />
            </button>
            <span className="text-sm font-medium" style={{ color: 'var(--text-primary)' }}>
                {checked ? 'Yes' : 'No'}
            </span>
        </div>
    );
};

export default FormSwitch;
